import { useEffect, useRef } from "react";
import { useLocation, useMatch } from "react-router";
import { useInstagramSearch } from "./useInstagramSearch";

/**
 * @description The curated influencers feed, the landing screen of the page.
 */
export const useIsInstagramSearchInfluencers = () => {
  const config = useInstagramSearch((state) => state.config);

  return useMatch(config.router.influencers) !== null;
};

/**
 * @description The results of the aside filters form.
 */
export const useIsInstagramSearchProfiles = () => {
  const config = useInstagramSearch((state) => state.config);

  return useMatch(config.router.profiles) !== null;
};

/**
 * @description Id of the currently opened list, `undefined` on every other
 * screen. Matches against the location instead of reading route params, so it
 * also works outside of the `<Routes>` subtree, where the aside is rendered.
 */
export const useInstagramSearchListId = () => {
  const config = useInstagramSearch((state) => state.config);

  return useMatch(config.router.list)?.params.listId;
};

/**
 * @description Selection belongs to the screen it was made on, so leaving the
 * screen drops it.
 */
export const useInstagramSearchSelectionReset = () => {
  const { key } = useLocation();
  const initialKey = useRef(key);

  useEffect(() => {
    if (key === initialKey.current) {
      return;
    }

    useInstagramSearch.setState({
      selection: new Set(),
      listsSelection: new Set(),
    });
  }, [key]);
};
